import React, { useState } from 'react';
import { Image as ImageIcon } from 'lucide-react';

const ProfileGallery = ({ name, photos = [] }) => {
  const [lightboxIdx, setLightboxIdx] = useState(null);
  const frames = [...photos];
  while (frames.length < 6) frames.push(null);
  const visible = frames.slice(0, 6);

  return (
    <>
      <div className="mt-8">
        <div className="flex items-center gap-2 mb-4">
          <ImageIcon className="w-5 h-5 text-fnl-pink" />
          <h2 className="text-xl font-bold text-white">Photos</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4" data-testid="profile-gallery">
          {visible.map((src, idx) => (
            <div
              key={src || `empty-${idx}`}
              className="aspect-square rounded-2xl overflow-hidden bg-fnl-purple/40 border border-purple-900/40 relative group"
              onClick={() => src && setLightboxIdx(idx)}
              data-testid={`profile-gallery-slot-${idx}`}
            >
              {src ? (
                <>
                  <img src={src} alt={`${name} ${idx + 1}`} className="w-full h-full object-cover cursor-pointer transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors pointer-events-none" />
                </>
              ) : (
                <div className="w-full h-full flex flex-col items-center justify-center text-purple-700">
                  <ImageIcon className="w-8 h-8 mb-1" />
                  <span className="text-xs uppercase tracking-wider">Empty slot</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {lightboxIdx !== null && visible[lightboxIdx] && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-6 cursor-zoom-out"
          onClick={() => setLightboxIdx(null)}
          data-testid="profile-lightbox"
        >
          <img src={visible[lightboxIdx]} alt="" className="max-w-full max-h-full rounded-2xl" />
        </div>
      )}
    </>
  );
};

export default ProfileGallery;
